import React, { useEffect, useRef, useState } from 'react';
import { Box, OSKThemeType, Spinner } from 'oskcomponents';
import { OSKScene, noop } from 'oskcore';
import { connect } from 'react-redux';
import { SigmaOrderDetails } from '~/redux/modules/data/orders';
import { RootState } from '~/redux/store';
import { SceneGroup, SceneItem } from '~/molecules';
import { useTheme } from 'styled-components';

export type CollectsTabProps = {
    /** Whether the tab is loading or not */
    isLoading: boolean;
    /** The currently active order to render */
    order?: SigmaOrderDetails;
};

export const CollectsTab = ({ isLoading, order }: CollectsTabProps) => {
    const [collects, setCollects] = useState<string[]>([]);
    const groupedCollects = useRef<Record<string, OSKScene[]>>({});
    const theme = useTheme() as OSKThemeType;

    useEffect(() => {
        if (order) {
            const byCollect = (order.scenes ?? []).reduce((acc, cur) => {
                const task_id = cur.task_id;
                acc[task_id] = acc[task_id] ?? [];
                acc[task_id].push(cur);
                return acc;
            }, {} as Record<string, Array<OSKScene>>);

            groupedCollects.current = byCollect;
            setCollects(Object.keys(byCollect));
        }
    }, [order]);

    if (isLoading) {
        return (
            <Box style={{ width: '100%', height: '100%' }} grow center="all">
                <Spinner variant="Box" size="Large" />
            </Box>
        );
    } else if (order) {
        return (
            <Box style={{ width: '100%', padding: '20px' }} grow col>
                {collects.length === 0 && (
                    <Box grow center="all">
                        No collects for this order yet.
                    </Box>
                )}
                {collects.map((taskId) => {
                    const activeGroup = groupedCollects.current[taskId] ?? [];

                    return (
                        <SceneGroup
                            selectedIcon="hidden"
                            defaultExpanded={true}
                            key={`collect_${taskId}`}
                            mb={20}
                            taskId={taskId}
                        >
                            {activeGroup.map((x) => (
                                <SceneItem
                                    intentOnly={true}
                                    fileId={x.id}
                                    hideIcon={true}
                                    key={`collect_item_${x.id}`}
                                    data={x}
                                    style={{
                                        margin: '0px 0px',
                                        backgroundColor: theme.colors.white,
                                    }}
                                />
                            ))}
                        </SceneGroup>
                    );
                })}
            </Box>
        );
    } else {
        return <></>;
    }
};

const mapStateToProps = (state: RootState) => {
    return {
        isLoading: state.data.orders.loadingSingleOrder,
        order: state.data.orders.activeOrder,
    };
};

export default connect(mapStateToProps, noop)(CollectsTab);
